import { Component, OnInit } from '@angular/core';
import { Rucher } from '../../../models/rucher';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../../../app.service';
import { NgbDateStruct, NgbDatepickerConfig, NgbDateParserFormatter, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateFRParserFormatter } from '../../../outils/ngb-datepicker-fr-formatter';
import { Intervention } from '../../../models/intervention';

@Component({
  selector: 'app-rucher',
  templateUrl: './intervention.component.html',
  styleUrls: ['./intervention.component.css']
})
export class InterventionComponent implements OnInit {
  private id: string;
  private rucher: Rucher = new Rucher();
  private listeInterventions: Intervention[];
  
  constructor(private route: ActivatedRoute, private router: Router, private appService: AppService) {
  }

  ngOnInit() {
    if (this.appService.nomenclatures.length === 0) {
      this.router.navigate(['']);
    } else {
      this.id = this.route.snapshot.paramMap.get('id');
      this.rucher = this.appService.getRucher(this.id);
      this.router.navigate(['listeinter', this.id], { skipLocationChange: true, relativeTo: this.route });
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/principal/interventions/intervention/intervention.component.ts